import _ from 'lodash'

import {
  CLEAR_USER_KEY_SUCCESS,
  LIST_USERS_FAILURE,
  LIST_USERS_SUCCESS,
  SET_USER_IS_LOADING_SUCCESS,
  SET_USER_SELECTED_SUCCESS
} from '../actions/user'

const user = (state = {}, action) => {
  switch (action.type) {
    case LIST_USERS_SUCCESS:
      return {
        ...state,
        [action.data.key]: {
          list: action.data.list
        }
      }
    case SET_USER_IS_LOADING_SUCCESS:
      return {
        ...state,
        [action.data.key]: {
          isLoading: action.data.isLoading
        }
      }
    case SET_USER_SELECTED_SUCCESS:
      return {
        ...state,
        [action.data.key]: {
          selected: action.data.selected
        }
      }
    case CLEAR_USER_KEY_SUCCESS:
      return _.omit(state, action.data.key)
    case LIST_USERS_FAILURE:
    default:
      return state
  }
}

export default user


// WEBPACK FOOTER //
// ./src/reducers/user.js